var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080.57 668.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path);}.cls-5{mix-blend-mode:soft-light;fill:url(#linear-gradient-2);}.cls-10,.cls-100,.cls-102,.cls-103,.cls-11,.cls-110,.cls-111,.cls-118,.cls-18,.cls-19,.cls-23,.cls-27,.cls-31,.cls-32,.cls-33,.cls-40,.cls-41,.cls-48,.cls-49,.cls-50,.cls-52,.cls-53,.cls-54,.cls-56,.cls-57,.cls-6,.cls-64,.cls-65,.cls-69,.cls-7,.cls-70,.cls-77,.cls-78,.cls-8,.cls-82,.cls-83,.cls-90,.cls-91,.cls-92,.cls-94,.cls-95,.cls-96,.cls-98,.cls-99{mix-blend-mode:multiply;}.cls-6{fill:url(#radial-gradient);}.cls-7{fill:url(#radial-gradient-2);}.cls-8{fill:url(#radial-gradient-3);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#radial-gradient-4);}.cls-11{fill:url(#radial-gradient-5);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#radial-gradient-6);}.cls-19{fill:url(#radial-gradient-7);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#radial-gradient-8);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#radial-gradient-9);}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#radial-gradient-10);}.cls-32{fill:url(#radial-gradient-11);}.cls-33{fill:url(#radial-gradient-12);}.cls-34{fill:url(#linear-gradient-19);}.cls-35{fill:url(#linear-gradient-20);}.cls-36{fill:url(#linear-gradient-21);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:url(#linear-gradient-23);}.cls-39{fill:url(#linear-gradient-24);}.cls-40{fill:url(#radial-gradient-13);}.cls-41{fill:url(#radial-gradient-14);}.cls-42{fill:url(#linear-gradient-25);}.cls-43{fill:url(#linear-gradient-26);}.cls-44{fill:url(#linear-gradient-27);}.cls-45{fill:url(#linear-gradient-28);}.cls-46{fill:url(#linear-gradient-29);}.cls-47{fill:url(#linear-gradient-30);}.cls-48{fill:url(#radial-gradient-15);}.cls-49{fill:url(#radial-gradient-16);}.cls-50{fill:url(#radial-gradient-17);}.cls-51{fill:url(#linear-gradient-31);}.cls-52{fill:url(#radial-gradient-18);}.cls-53{fill:url(#radial-gradient-19);}.cls-54{fill:url(#radial-gradient-20);}.cls-55{fill:url(#linear-gradient-32);}.cls-56{fill:url(#radial-gradient-21);}.cls-57{fill:url(#radial-gradient-22);}.cls-58{fill:url(#linear-gradient-33);}.cls-59{fill:url(#linear-gradient-34);}.cls-60{fill:url(#linear-gradient-35);}.cls-61{fill:url(#linear-gradient-36);}.cls-62{fill:url(#linear-gradient-37);}.cls-63{fill:url(#linear-gradient-38);}.cls-64{fill:url(#radial-gradient-23);}.cls-65{fill:url(#radial-gradient-24);}.cls-66{fill:url(#linear-gradient-39);}.cls-67{fill:url(#linear-gradient-40);}.cls-68{fill:url(#linear-gradient-41);}.cls-69{fill:url(#radial-gradient-25);}.cls-70{fill:url(#radial-gradient-26);}.cls-71{fill:url(#linear-gradient-42);}.cls-72{fill:url(#linear-gradient-43);}.cls-73{fill:url(#linear-gradient-44);}.cls-74{fill:url(#linear-gradient-45);}.cls-75{fill:url(#linear-gradient-46);}.cls-76{fill:url(#linear-gradient-47);}.cls-77{fill:url(#radial-gradient-27);}.cls-78{fill:url(#radial-gradient-28);}.cls-79{fill:url(#linear-gradient-48);}.cls-80{fill:url(#linear-gradient-49);}.cls-81{fill:url(#linear-gradient-50);}.cls-82{fill:url(#radial-gradient-29);}.cls-83{fill:url(#radial-gradient-30);}.cls-84{fill:url(#linear-gradient-51);}.cls-85{fill:url(#linear-gradient-52);}.cls-86{fill:url(#linear-gradient-53);}.cls-87{fill:url(#linear-gradient-54);}.cls-88{fill:url(#linear-gradient-55);}.cls-89{fill:url(#linear-gradient-56);}.cls-90{fill:url(#radial-gradient-31);}.cls-91{fill:url(#radial-gradient-32);}.cls-92{fill:url(#radial-gradient-33);}.cls-93{fill:url(#linear-gradient-57);}.cls-94{fill:url(#radial-gradient-34);}.cls-95{fill:url(#radial-gradient-35);}.cls-96{fill:url(#radial-gradient-36);}.cls-97{fill:url(#linear-gradient-58);}.cls-98{fill:url(#radial-gradient-37);}.cls-99{fill:url(#radial-gradient-38);}.cls-100{fill:url(#radial-gradient-39);}.cls-101{fill:url(#linear-gradient-59);}.cls-102{fill:url(#radial-gradient-40);}.cls-103{fill:url(#radial-gradient-41);}.cls-104{fill:url(#linear-gradient-60);}.cls-105{fill:url(#linear-gradient-61);}.cls-106{fill:url(#linear-gradient-62);}.cls-107{fill:url(#linear-gradient-63);}.cls-108{fill:url(#linear-gradient-64);}.cls-109{fill:url(#linear-gradient-65);}.cls-110{fill:url(#radial-gradient-42);}.cls-111{fill:url(#radial-gradient-43);}.cls-112{fill:url(#linear-gradient-66);}.cls-113{fill:url(#linear-gradient-67);}.cls-114{fill:url(#linear-gradient-68);}.cls-115{fill:url(#linear-gradient-69);}.cls-116{fill:url(#linear-gradient-70);}.cls-117{fill:url(#linear-gradient-71);}.cls-118{opacity:0.75;fill:url(#radial-gradient-44);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 185.1,
    y1: 19.4,
    x2: 1078.38,
    y2: 625.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(180.57 21.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 713.08,
    height: 600,
    transform: "translate(713.08 600) rotate(180)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 538.15,
    y1: 42.5,
    x2: 765.35,
    y2: 497.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 900, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 2775.5,
    cy: -64834.62,
    r: 113.76,
    gradientTransform: "matrix(0.51, -0.09, 0, -0.02, -1645.99, -662.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -1414.65,
    cy: 12778.61,
    r: 113.54,
    gradientTransform: "matrix(0, -0.52, -0.02, 0, 257.52, -247.11)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -273.55,
    cy: -57906.4,
    r: 113.75,
    gradientTransform: "matrix(0.18, -0.49, -0.02, -0.01, -1052.44, -77.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2218.59,
    y1: 358.54,
    x2: 2329.22,
    y2: 350.84,
    gradientTransform: "matrix(-0.37, 0.93, 0.93, 0.37, 521.83, -1787.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#996c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a67f55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c0a470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d0bb81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d6c387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ccb980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b09d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#84704e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#533e2c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 2886.99,
    cy: 1789.16,
    r: 79.57,
    gradientTransform: "matrix(0, 1.08, 0.43, 0, -661.44, -2641.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 2982.7,
    cy: -2299.09,
    r: 88.81,
    gradientTransform: "matrix(0, 0.99, 0.59, 0, 1419.13, -2444.34)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 78.34,
    y1: -899.01,
    x2: 179.7,
    y2: -879.14,
    gradientTransform: "matrix(-0.44, -0.9, -0.9, 0.44, -457.51, 987.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 223.12,
    y1: -817.61,
    x2: 149.74,
    y2: -870.7,
    gradientTransform: "matrix(-0.44, -0.9, -0.9, 0.44, -457.51, 987.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 236.52,
    y1: -768.68,
    x2: 86.77,
    y2: -877.02,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 6420.96,
    y1: -6895.21,
    x2: 6386.64,
    y2: -6797.47,
    gradientTransform: "matrix(-0.09, 0.18, -0.19, -0.09, -630.93, -1372.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#996c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9b6f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a27950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ad895c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#bda06d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d2bd82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d6c387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ac986a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#86714f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6a553c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#594430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#533e2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 8029.47,
    y1: -1155.64,
    x2: 7727.32,
    y2: -1098.96,
    gradientTransform: "matrix(0.11, 0.17, -0.18, 0.12, -1001.93, -705.43)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 639.49,
    y1: -8690.25,
    x2: 779.1,
    y2: -8534.78,
    gradientTransform: "matrix(-0.2, 0.01, -0.01, -0.21, 62.4, -1358.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 1947.41,
    cy: 3300.72,
    r: 91.65,
    gradientTransform: "matrix(-1.08, 0, 0, 0.43, 2462.65, -986.09)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 3279.19,
    cy: -2241.52,
    r: 102.29,
    gradientTransform: "matrix(0, 0.85, 0.59, 0, 1630.24, -2322.2)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 451.3,
    y1: 94.12,
    x2: 573.29,
    y2: 118.04,
    gradientTransform: "matrix(-1, -0.08, -0.08, 1, 1040.64, 306.03)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 589.66,
    y1: 349.06,
    x2: 666.06,
    y2: 367.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 1080.57, 21.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 5900.28,
    y1: -527.87,
    x2: 5636.15,
    y2: -786.62,
    gradientTransform: "matrix(0.09, 0.36, 0.24, -0.06, -83.58, -1747.81)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 3209.84,
    cy: -467.29,
    r: 80.69,
    gradientTransform: "matrix(0, 0.93, 0.76, 0, 683.56, -2684)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 490.17,
    y1: 259.18,
    x2: 576.57,
    y2: 275.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 1080.57, 21.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 273.19,
    y1: -771.84,
    x2: 158.61,
    y2: -854.74,
    gradientTransform: "matrix(-0.54, -0.84, -0.84, 0.54, -79.04, 875.68)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 3761.63,
    y1: 2182.92,
    x2: 3572.36,
    y2: 1997.51,
    gradientTransform: "matrix(-0.23, 0.29, 0.19, 0.15, 788.34, -1127.01)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 3637.03,
    cy: -901.04,
    r: 82.8,
    gradientTransform: "matrix(0, 0.93, 0.49, 0, 976.48, -2798.88)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2360.45,
    y1: -467.31,
    x2: 2431.1,
    y2: -453.46,
    gradientTransform: "matrix(0.91, 0.41, 0.41, -0.91, -1282.88, -836.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 694.8,
    y1: 778.94,
    x2: 612.48,
    y2: 742.8,
    gradientTransform: "matrix(-0.96, 0.29, 0.29, 0.96, 1146.57, -347.09)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2693.26,
    y1: -6927.53,
    x2: 2540.28,
    y2: -7077.4,
    gradientTransform: "matrix(0.03, -0.37, -0.25, -0.02, -1253.7, 1373.62)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 2626.6,
    cy: 2606.44,
    r: 91.66,
    gradientTransform: "matrix(-1.08, 0, 0, 0.43, 3121, -615.57)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 2973.44,
    cy: -1839.64,
    r: 102.29,
    gradientTransform: "matrix(0, 1.22, 0.59, 0, 1279.83, -3084.77)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 1941.13,
    cy: -2665.11,
    r: 76.53,
    gradientTransform: "matrix(1.22, 0, 0, -0.78, -2106.55, -1642.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 15.17,
    y1: -1297.47,
    x2: 208.98,
    y2: -1259.47,
    gradientTransform: "matrix(-0.25, -0.97, -0.97, 0.25, -755.28, 936.18)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 292,
    y1: -1141.81,
    x2: 151.67,
    y2: -1243.33,
    gradientTransform: "matrix(-0.25, -0.97, -0.97, 0.25, -755.28, 936.18)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 317.61,
    y1: -1048.25,
    x2: 31.28,
    y2: -1255.42,
    gradientTransform: "matrix(-0.25, -0.97, -0.97, 0.25, -755.28, 936.18)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 4902.86,
    y1: -8019.52,
    x2: 4837.21,
    y2: -7832.53,
    gradientTransform: "matrix(-0.13, 0.16, -0.17, -0.13, -456.68, -1374.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 8593.61,
    y1: -2885.35,
    x2: 8015.74,
    y2: -2776.96,
    gradientTransform: "matrix(0.08, 0.19, -0.2, 0.08, -955.05, -795.44)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -935.07,
    y1: -8143.96,
    x2: -668.08,
    y2: -7846.63,
    gradientTransform: "matrix(-0.2, -0.03, 0.03, -0.21, 219.15, -1218.86)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 1939.2,
    cy: 4986.08,
    r: 61.16,
    gradientTransform: "matrix(-1.08, 0, 0, 0.28, 2604.06, -1027.83)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 3490,
    cy: -86.99,
    r: 64.87,
    gradientTransform: "matrix(0, 0.85, 0.47, 0, 520.42, -2594.09)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2670,
    y1: -1367.45,
    x2: 2750.2,
    y2: -1351.73,
    gradientTransform: "matrix(0.72, 0.7, 0.7, -0.72, -340.77, -2487.06)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2784.55,
    y1: -1303.04,
    x2: 2726.49,
    y2: -1345.05,
    gradientTransform: "matrix(0.72, 0.7, 0.7, -0.72, -340.77, -2487.06)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2795.15,
    y1: -1264.32,
    x2: 2676.66,
    y2: -1350.05,
    gradientTransform: "matrix(0.72, 0.7, 0.7, -0.72, -340.77, -2487.06)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -3159.99,
    y1: 1401.71,
    x2: -3187.16,
    y2: 1479.09,
    gradientTransform: "matrix(0.02, -0.2, 0.21, 0.02, 267.91, -307.44)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -4264.38,
    y1: -5085.21,
    x2: -4503.5,
    y2: -5040.35,
    gradientTransform: "matrix(-0.16, -0.12, 0.12, -0.17, 390.55, -1060.25)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 3201.89,
    y1: 3499.96,
    x2: 3312.39,
    y2: 3623.02,
    gradientTransform: "matrix(0.19, -0.08, 0.09, 0.19, -390.19, -85.65)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 3824.62,
    cy: -57847.66,
    r: 105.04,
    gradientTransform: "matrix(0.52, -0.02, 0, -0.02, -1586.34, -699.78)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -1687.87,
    cy: -13148.96,
    r: 105,
    gradientTransform: "matrix(-0.28, -0.44, -0.02, 0.01, -281.94, -111.27)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 496.11,
    cy: -76564.79,
    r: 105.02,
    gradientTransform: "matrix(0.24, -0.46, -0.02, -0.01, -1075.85, -41.74)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1810.66,
    y1: 742.77,
    x2: 1912.83,
    y2: 735.65,
    gradientTransform: "matrix(-0.49, 0.87, 0.87, 0.49, 708.02, -1531.71)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 3462.72,
    cy: -63281.01,
    r: 111.69,
    gradientTransform: "matrix(0.52, 0, 0, -0.02, -1609.16, -764.96)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -1701.52,
    cy: -2701.37,
    r: 111.63,
    gradientTransform: "matrix(-0.26, -0.45, -0.02, 0.01, -323.14, -135.53)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 127.04,
    cy: -71693.89,
    r: 111.57,
    gradientTransform: "matrix(0.26, -0.45, -0.02, -0.01, -1119.2, -91.99)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 2002.81,
    y1: 644.41,
    x2: 2111.41,
    y2: 636.85,
    gradientTransform: "matrix(-0.52, 0.85, 0.85, 0.52, 710.94, -1525.4)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 2262.29,
    cy: 3376.28,
    r: 72.32,
    gradientTransform: "matrix(-1.08, 0, 0, 0.28, 2654.08, -680.37)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 3206.75,
    cy: -1344.18,
    r: 76.71,
    gradientTransform: "matrix(0, 0.85, 0.59, 0, 966.33, -2449.5)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 737.38,
    y1: 211.52,
    x2: 630.98,
    y2: 157.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 1080.57, 21.6)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 708.36,
    y1: 211.05,
    x2: 768.36,
    y2: 302.25,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1623.12,
    y1: 241.14,
    x2: 1420.32,
    y2: 94.41,
    gradientTransform: "matrix(-0.91, 0.41, 0.41, 0.91, 1690.55, -466.16)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 6106.24,
    y1: 988.76,
    x2: 6059.76,
    y2: 1121.12,
    gradientTransform: "matrix(0.18, 0.1, -0.1, 0.19, -826.86, -565.35)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 886.31,
    y1: 2528.76,
    x2: 477.1,
    y2: 2605.51,
    gradientTransform: "matrix(0.17, -0.11, 0.11, 0.18, -171.47, -174.31)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 7572.09,
    y1: -4520.84,
    x2: 7761.21,
    y2: -4310.24,
    gradientTransform: "matrix(0.01, 0.2, -0.21, 0.01, -790.99, -1258.49)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 1985.75,
    cy: 3666.9,
    r: 94.05,
    gradientTransform: "matrix(-1.08, 0, 0, 0.43, 2595.66, -1008.86)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 3311.74,
    cy: -2183.88,
    r: 104.97,
    gradientTransform: "matrix(0, 0.99, 0.59, 0, 1675.16, -2700.82)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 513.42,
    y1: 418.45,
    x2: 509.9,
    y2: 527.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 1080.57, 21.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 511.14,
    y1: 491.96,
    x2: 507.54,
    y2: 576.56,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 7647.08,
    y1: -6273.57,
    x2: 7403.9,
    y2: -6511.8,
    gradientTransform: "matrix(0.36, 0.08, 0.06, -0.24, -1950.01, -1674.63)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 1738.66,
    cy: 3243.85,
    r: 104.51,
    gradientTransform: "matrix(-1.08, 0, 0, 0.28, 1961.41, -816.07)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 2880.61,
    cy: -505.44,
    r: 110.85,
    gradientTransform: "matrix(0, 0.85, 0.59, 0, 337.38, -2363.97)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1025.47,
    y1: -1739.18,
    x2: 1172.89,
    y2: -1710.28,
    gradientTransform: "matrix(0.35, -0.94, -0.94, -0.35, -1702.89, 528.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1236.04,
    y1: -1620.78,
    x2: 1129.3,
    y2: -1698.01,
    gradientTransform: "matrix(0.35, -0.94, -0.94, -0.35, -1702.89, 528.58)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1255.52,
    y1: -1549.62,
    x2: 1037.73,
    y2: -1707.2,
    gradientTransform: "matrix(0.35, -0.94, -0.94, -0.35, -1702.89, 528.58)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 231.23,
    y1: -5646.11,
    x2: 181.27,
    y2: -5503.84,
    gradientTransform: "matrix(-0.19, 0.06, -0.06, -0.2, -189.5, -1107.63)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 3986.84,
    y1: -5668.97,
    x2: 3547.27,
    y2: -5586.52,
    gradientTransform: "matrix(-0.04, 0.2, -0.21, -0.04, -928.94, -913.15)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1246.61,
    y1: -2981.54,
    x2: -1043.55,
    y2: -2755.41,
    gradientTransform: "matrix(-0.15, -0.14, 0.14, -0.16, 279.13, -595.89)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 2046.19,
    cy: 2941.02,
    r: 94.05,
    gradientTransform: "matrix(-1.08, 0, 0, 0.43, 2383.2, -851.76)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 2990.62,
    cy: -2134.52,
    r: 104.97,
    gradientTransform: "matrix(0, 0.99, 0.59, 0, 1367.97, -2538.23)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1755.76,
    y1: 804.95,
    x2: 1869.23,
    y2: 827.19,
    gradientTransform: "matrix(-0.43, 0.9, 0.9, 0.43, 333.21, -1647.92)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 791.14,
    y1: 343.02,
    x2: 817.54,
    y2: 427.02,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 6523.18,
    y1: -6446.72,
    x2: 6277.51,
    y2: -6687.38,
    gradientTransform: "matrix(0.37, 0.04, 0.02, -0.25, -2081.13, -1497.12)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 2437.83,
    cy: 2290.44,
    r: 55.18,
    gradientTransform: "matrix(-1.08, 0, 0, 0.43, 2748.03, -677.41)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 3012.16,
    cy: -1532.57,
    r: 61.59,
    gradientTransform: "matrix(0, 0.99, 0.59, 0, 967.29, -2652.12)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 2717.6,
    y1: -1348.58,
    x2: 2817.57,
    y2: -1328.98,
    gradientTransform: "matrix(0.9, 0.45, 0.45, -0.9, -1644.11, -2098.28)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 2859.06,
    y1: -1258.45,
    x2: 2774.32,
    y2: -1319.77,
    gradientTransform: "matrix(0.9, 0.45, 0.45, -0.9, -1644.11, -2098.28)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 2869.45,
    y1: -1215.35,
    x2: 2719.66,
    y2: -1323.73,
    gradientTransform: "matrix(0.9, 0.45, 0.45, -0.9, -1644.11, -2098.28)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 2970.12,
    y1: -11921.38,
    x2: 3017.41,
    y2: -12046.07,
    gradientTransform: "matrix(0.15, -0.14, -0.11, -0.11, -1628.24, -636.49)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -6543.76,
    y1: -6348.04,
    x2: -6859.27,
    y2: -6486.07,
    gradientTransform: "matrix(-0.07, -0.14, -0.17, 0.08, -1435.61, -157.07)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -6704.28,
    y1: 2500.33,
    x2: -7027.07,
    y2: 2541.96,
    gradientTransform: "matrix(-0.15, -0.04, -0.03, 0.11, -945.27, -266.74)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 3255.01,
    cy: 36497.74,
    r: 98.01,
    gradientTransform: "matrix(-0.03, 0.52, 0.02, 0, -479.79, -1650.74)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 1905.24,
    cy: -48388.89,
    r: 98.05,
    gradientTransform: "matrix(0.46, -0.23, -0.01, -0.02, -1196.37, -410.88)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 3524.06,
    cy: -17192.94,
    r: 98.11,
    gradientTransform: "matrix(0.43, 0.29, 0.01, -0.02, -1186.08, -1208.26)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 281.31,
    y1: -552.33,
    x2: 376.69,
    y2: -558.97,
    gradientTransform: "matrix(-0.82, -0.58, -0.58, 0.82, 118.34, 716.97)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 4104.45,
    cy: -34014.35,
    r: 110.77,
    gradientTransform: "matrix(0.48, 0.2, 0.01, -0.02, -1450.07, -1155.25)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: -1000.92,
    cy: -31054.96,
    r: 110.87,
    gradientTransform: "matrix(-0.07, -0.51, -0.02, 0, -505.32, -78.51)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 1466,
    cy: -70880.39,
    r: 110.81,
    gradientTransform: "matrix(0.41, -0.32, -0.01, -0.02, -1257.36, -344.34)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1305.47,
    y1: 605.4,
    x2: 1413.28,
    y2: 597.9,
    gradientTransform: "matrix(-0.81, 0.59, 0.59, 0.81, 983.4, -962.42)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 3676.11,
    cy: -32322.04,
    r: 93.13,
    gradientTransform: "matrix(0.48, 0.19, 0.01, -0.02, -1450.51, -1146.89)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: -714.23,
    cy: -23011.22,
    r: 93.19,
    gradientTransform: "matrix(-0.07, -0.51, -0.02, 0, -502.05, -73.67)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 1322.3,
    cy: -60291.58,
    r: 93.04,
    gradientTransform: "matrix(0.41, -0.32, -0.01, -0.02, -1255.94, -337.07)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1397.77,
    y1: 394.86,
    x2: 1488.41,
    y2: 388.55,
    gradientTransform: "matrix(-0.81, 0.59, 0.59, 0.81, 982.41, -964.62)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 2699.92,
    cy: 1214.48,
    r: 61.07,
    gradientTransform: "matrix(0, 1.08, 0.43, 0, -472.74, -2733.93)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 2675.38,
    cy: -2188.85,
    r: 68.16,
    gradientTransform: "matrix(0, 0.99, 0.59, 0, 1308.56, -2431.49)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 361.69,
    y1: -737.23,
    x2: 439.48,
    y2: -721.97,
    gradientTransform: "matrix(-0.59, -0.81, -0.81, 0.59, -129.03, 947.61)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 472.81,
    y1: -674.74,
    x2: 416.48,
    y2: -715.5,
    gradientTransform: "matrix(-0.59, -0.81, -0.81, 0.59, -129.03, 947.61)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 483.09,
    y1: -637.19,
    x2: 368.16,
    y2: -720.35,
    gradientTransform: "matrix(-0.59, -0.81, -0.81, 0.59, -129.03, 947.61)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 6239.73,
    y1: -5436.99,
    x2: 6213.39,
    y2: -5361.98,
    gradientTransform: "matrix(-0.06, 0.2, -0.2, -0.06, -715.07, -1378.08)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 6546.39,
    y1: -613.17,
    x2: 6314.53,
    y2: -569.68,
    gradientTransform: "matrix(0.14, 0.15, -0.15, 0.15, -962.95, -655.54)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1801.15,
    y1: -7762.78,
    x2: 1908.33,
    y2: -7643.42,
    gradientTransform: "matrix(-0.2, 0.05, -0.05, -0.2, -29.33, -1484.32)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 1249.6,
    cy: 3571.39,
    r: 74.06,
    gradientTransform: "matrix(-1.08, 0, 0, 0.28, 1542.14, -825.49)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 2737.89,
    cy: 389.12,
    r: 78.55,
    gradientTransform: "matrix(0, 0.85, 0.59, 0, -61.82, -2163.05)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1213.14,
    y1: -2039.15,
    x2: 1312.71,
    y2: -2019.63,
    gradientTransform: "matrix(0.6, -0.8, -0.8, -0.6, -1986.96, -27.58)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1355.36,
    y1: -1959.18,
    x2: 1283.27,
    y2: -2011.34,
    gradientTransform: "matrix(0.6, -0.8, -0.8, -0.6, -1986.96, -27.58)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1368.52,
    y1: -1911.11,
    x2: 1221.42,
    y2: -2017.54,
    gradientTransform: "matrix(0.6, -0.8, -0.8, -0.6, -1986.96, -27.58)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1421.69,
    y1: -5950.46,
    x2: -1455.41,
    y2: -5854.41,
    gradientTransform: "matrix(-0.2, 0, 0, -0.21, -78.06, -1101.3)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 3281.45,
    y1: -7256.41,
    x2: 2984.73,
    y2: -7200.75,
    gradientTransform: "matrix(-0.1, 0.18, -0.18, -0.1, -841.83, -1130.39)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -2437.61,
    y1: -1681.35,
    x2: -2300.42,
    y2: -1528.58,
    gradientTransform: "matrix(-0.1, -0.18, 0.18, -0.11, 222.27, -476.05)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 280.19,
    cy: 246.6,
    r: 748.2,
    gradientTransform: "matrix(1, 0, 0, -0.65, 0, 513.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d3d3d3",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#505050",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.57,
    y: 21.6,
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M645.92,607.89l.79-.52L240.22-6.87l-.8.52ZM224.42-6.35l.8-.52L631.71,607.37l-.79.52Zm-15,0,.8-.52L616.71,607.37l-.79.52Zm-15,0,.79-.52L601.71,607.37l-.79.52Zm-15,0,.79-.52L586.71,607.37l-.79.52Zm-15,0,.79-.52L571.71,607.37l-.79.52Zm-15,0,.79-.52L556.71,607.37l-.79.52Zm-15,0,.79-.52L541.71,607.37l-.79.52Zm-15,0,.79-.52L526.71,607.37l-.79.52Zm-15,0,.79-.52L511.71,607.37l-.79.52Zm-15,0,.79-.52L496.71,607.37l-.79.52Zm-15,0,.79-.52L481.71,607.37l-.79.52Zm-15,0,.79-.52L466.71,607.37l-.79.52Zm-15,0,.79-.52L451.71,607.37l-.79.52Zm-15,0,.79-.52L436.71,607.37l-.79.52Zm-15,0,.79-.52L421.71,607.37l-.79.52Zm-15,0,.79-.52L406.71,607.37l-.79.52Zm-15,0,.79-.52L391.71,607.37l-.79.52Zm-15,0,.79-.52,406.5,614.24-.8.52Zm-15,0,.8-.52L361.72,607.37l-.8.52Zm-15,0,.8-.52L346.72,607.37l-.8.52Zm-15,0,.8-.52L331.72,607.37l-.8.52Zm-15,0,.8-.52L316.72,607.37l-.8.52Zm-15,0,.8-.52L301.72,607.37l-.8.52Zm-15,0,.8-.52L286.72,607.37l-.8.52Zm-15,0,.8-.52L271.72,607.37l-.8.52Zm-15,0,.8-.52L256.72,607.37l-.8.52Zm-15,0,.8-.52L241.72,607.37l-.8.52Zm-15,0,.8-.52L226.72,607.37l-.8.52Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.82,424.42c-.23-1.31-26.46,2.13-58.59,7.67s-58,11.09-57.78,12.39S-24.09,442.34,8,436.8,66,425.72,65.82,424.42Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: -11.97,
    cy: 487.67,
    rx: 2.39,
    ry: 59.04,
    transform: "translate(-134.25 126.85) rotate(-39.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M59.62,423.27c-1.24-.46-11.38,24-22.65,54.57s-19.4,55.78-18.16,56.23,11.38-24,22.65-54.57S60.86,423.72,59.62,423.27Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.94,525,61.55,421.94-47.9,437.7ZM59.72,423.38l-40.1,99.34-65.38-84.16Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 104.56,
    cy: 489.85,
    rx: 34.07,
    ry: 86.31,
    transform: "translate(139.77 32.12) rotate(-4.82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 58.46,
    cy: 493.76,
    rx: 52.57,
    ry: 87.48,
    transform: "translate(-236.66 370.69) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "253.91 485.07 289.72 538.09 282.18 428.09 253.91 485.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "253.91 485.07 189.96 489.42 282.18 428.09 253.91 485.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "253.91 485.07 189.96 489.42 289.72 538.09 253.91 485.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M73.32,463.46s6.61-12.61,14.39-28.36,13.8-28.66,13.8-28.66-6.61,12.62-14.39,28.37S73.32,463.46,73.32,463.46Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M108.9,516.22s-7.68-12-17.5-26.56-18.05-26.19-18.05-26.19,7.68,12,17.5,26.56S108.9,516.22,108.9,516.22Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M9.39,467.84s14.34-.65,32-1.86,32-2.52,32-2.52-14.34.65-32,1.86S9.39,467.84,9.39,467.84Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 350.28,
    cy: 427.38,
    rx: 99.41,
    ry: 39.24,
    transform: "translate(-21.55 434.42) rotate(-49.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 303.57,
    cy: 455.19,
    rx: 60.55,
    ry: 86.64,
    transform: "translate(-42.03 626.81) rotate(-72.21)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "506.45 465.15 581.3 387.89 457.8 280.39 506.45 465.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "506.45 465.15 416.24 441.13 457.8 280.39 506.45 465.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.88,443.45s-11.51-41.17-24.95-92.16-23.7-92.5-23.7-92.5S288.74,300,302.17,351,325.88,443.45,325.88,443.45Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 329,
    cy: 297.73,
    rx: 61.22,
    ry: 74.95,
    transform: "translate(87.58 182.18) rotate(-24.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "500.55 331.9 577.04 341.12 584.86 224.11 500.55 331.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "500.55 331.9 475.17 270.04 584.86 224.11 500.55 331.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M320,310.25s18.5-24.4,41.76-54.15,42.49-53.59,42.49-53.59-18.5,24.4-41.76,54.16S320,310.25,320,310.25Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 533.79,
    cy: 579.61,
    rx: 40.68,
    ry: 76.91,
    transform: "translate(-68.59 512.52) rotate(-40.89)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "736.25 521.96 680.45 549.64 727.05 632.21 736.25 521.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "736.25 521.96 780.84 552.52 727.05 632.21 736.25 521.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M555.67,500.42s-1.69,24.69-4.22,55.12-5,55.07-5,55.07,1.69-24.7,4.23-55.13S555.67,500.42,555.67,500.42Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 272.05,
    cy: 500.36,
    rx: 99.41,
    ry: 39.24,
    transform: "translate(-81.7 719.12) rotate(-81.72)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 191.02,
    cy: 537.9,
    rx: 60.55,
    ry: 124.63,
    transform: "translate(-176.43 399.81) rotate(-54.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 258.34,
    cy: 437.95,
    rx: 93.23,
    ry: 59.75,
    transform: "translate(-44.55 302.03) rotate(-41.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "396.16 504.96 442.75 618.08 471.12 409.18 396.16 504.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "396.16 504.96 274.73 488.38 471.12 409.18 396.16 504.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "396.16 504.96 274.73 488.38 442.75 618.08 396.16 504.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M215.56,483.33s17.25-21.08,37.91-47.55,36.91-48.34,36.91-48.34S273.13,408.52,252.47,435,215.56,483.33,215.56,483.33Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M261.81,595.87s-9.76-25.43-22.52-56.49-23.68-56-23.68-56,9.76,25.43,22.51,56.5S261.81,595.87,261.81,595.87Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M94.16,466.82s27.1,4.32,60.64,8.88,60.81,7.64,60.81,7.64S188.51,479,155,474.45,94.16,466.82,94.16,466.82Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 500.98,
    cy: 376.46,
    rx: 66.33,
    ry: 17.23,
    transform: "translate(87.62 597.93) rotate(-55.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 479.7,
    cy: 361.85,
    rx: 30.41,
    ry: 54.94,
    transform: "translate(74.53 249.43) rotate(-24.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "680.97 364.52 640.06 334.71 675.27 414.53 680.97 364.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "680.97 364.52 727.39 344.09 675.27 414.53 680.97 364.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "680.97 364.52 727.39 344.09 640.06 334.71 680.97 364.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M500.43,342.92s-1.53,11.17-3.08,25-2.56,25-2.56,25,1.52-11.17,3.08-25S500.43,342.92,500.43,342.92Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M459.76,313.24s8.94,6.86,20.16,15.06,20.48,14.62,20.48,14.62-8.94-6.85-20.17-15.05S459.76,313.24,459.76,313.24Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M546.81,322.47s-10.49,4.34-23.31,10-23.1,10.47-23.1,10.47,10.5-4.34,23.32-10S546.81,322.47,546.81,322.47Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M499,434.07c-.05-1.22-24.48-1.24-54.57,0s-54.44,3.15-54.39,4.37,24.48,1.23,54.57,0S499.06,435.29,499,434.07Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M391,436.5c-1,.65,11.17,21.82,27.25,47.28s30,45.57,31,44.92S438.11,506.88,422,481.42,392.08,435.85,391,436.5Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M493.48,432.27c-1.08-.57-13.31,20.58-27.32,47.24s-24.5,48.72-23.42,49.29,13.32-20.58,27.33-47.24S494.56,432.83,493.48,432.27Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M444.87,520.65l50.54-89.36-102.12,1.22Zm48.69-88.27L444.85,518.5l-49.71-84.94Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M259.65,547.85c0-1.29-26-2.12-58-1.84s-57.95,1.56-57.94,2.86,26,2.12,58,1.84S259.66,549.15,259.65,547.85Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M144.85,546.88c-1.11.66,11.15,23.55,27.4,51.13s30.32,49.41,31.44,48.75-11.15-23.55-27.39-51.13S146,546.22,144.85,546.88Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M253.83,545.76c-1.13-.64-14.82,21.43-30.59,49.29s-27.62,51-26.49,51.6,14.82-21.43,30.58-49.29S255,546.4,253.83,545.76Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M199.27,638.07l56.64-93.29-108.54-2.06Zm54.64-92.19-54.59,89.9-50-91.89Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 200.23,
    cy: 270.63,
    rx: 78.44,
    ry: 20.37,
    transform: "translate(58.97 391.03) rotate(-70.57)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 170.65,
    cy: 266.33,
    rx: 45.4,
    ry: 64.97,
    transform: "translate(40.4 229.23) rotate(-46.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "378.98 254.55 452.22 208.24 303.01 213.94 378.98 254.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "378.98 254.55 382.24 341.29 303.01 213.94 378.98 254.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "378.98 254.55 382.24 341.29 452.22 208.24 378.98 254.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M198.4,233s-16.81-9.47-37.8-20.65-38.23-19.86-38.23-19.86,16.81,9.46,37.81,20.65S198.4,233,198.4,233Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M271.27,187s-16.55,9.92-36.66,22.61-36.19,23.36-36.19,23.36S215,223,235.08,210.33,271.27,187,271.27,187Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M201.69,319.69s-.29-19.44-1.2-43.39-2.09-43.36-2.09-43.36.29,19.43,1.2,43.39S201.69,319.69,201.69,319.69Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 441.69,
    cy: 561.41,
    rx: 102.01,
    ry: 40.27,
    transform: "translate(-91.31 549.93) rotate(-49.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-65",
    cx: 382.7,
    cy: 561.41,
    rx: 62.13,
    ry: 103.4,
    transform: "matrix(0.4, -0.92, 0.92, 0.4, -104.55, 708.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "655.35 542.03 624.95 447.8 484.21 501.65 655.35 542.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "655.35 542.03 596.83 604.93 484.21 501.65 655.35 542.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M474.7,520.39s-38.43-8.46-85.66-19.6-85.4-20.74-85.4-20.74,38.43,8.46,85.67,19.6S474.7,520.39,474.7,520.39Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 75.54,
    cy: 97.59,
    rx: 113.35,
    ry: 29.44,
    transform: "translate(132.96 111.08) rotate(-48.49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 38.27,
    cy: 75.75,
    rx: 65.61,
    ry: 93.88,
    transform: "translate(152.53 44.38) rotate(-24.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "260.43 62.75 240.83 153.71 348.69 35.06 260.43 62.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "260.43 62.75 191.49 0 348.69 35.06 260.43 62.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "260.43 62.75 191.49 0 240.83 153.71 260.43 62.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M79.85,41.12s19.9-5.77,44.26-13.45,44-14.36,44-14.36-19.9,5.76-44.26,13.44S79.85,41.12,79.85,41.12Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M60.3,131.57s4.85-20.14,10.25-45.1,9.32-45.31,9.32-45.31S75,61.3,69.61,86.26,60.3,131.57,60.3,131.57Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M10.91-21.58S26-7.18,45.07,10.14s34.81,31,34.81,31S64.77,26.75,45.72,9.43,10.91-21.58,10.91-21.58Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-77",
    cx: 163.7,
    cy: 407.68,
    rx: 102.01,
    ry: 40.27,
    transform: "translate(-71.19 286.46) rotate(-49.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-78",
    cx: 104.71,
    cy: 407.68,
    rx: 62.13,
    ry: 103.4,
    transform: "translate(-130.14 361.52) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "374.61 383.75 331.67 293.39 197.8 365.98 374.61 383.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "374.61 383.75 324.31 454.52 197.8 365.98 374.61 383.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M194,362.13s-39.62-3.38-88.42-8.28-88.29-9.47-88.29-9.47,39.61,3.38,88.41,8.28S194,362.13,194,362.13Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-82",
    cx: 103.84,
    cy: 303.32,
    rx: 59.85,
    ry: 23.63,
    transform: "translate(-36.13 331.14) rotate(-72.21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-83",
    cx: 60.2,
    cy: 314.85,
    rx: 36.46,
    ry: 60.67,
    transform: "translate(-44.69 190.62) rotate(-52.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "248.47 312.91 197.35 300.24 273.32 367.27 248.47 312.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "248.47 312.91 303.26 259.67 273.47 367.22 248.47 312.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "248.47 312.91 303.26 259.67 197.51 300.19 248.47 312.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M122.7,238.07S110.63,250.2,95.5,264.9s-27.6,26.41-27.6,26.41S80,279.19,95.1,264.48,122.7,238.07,122.7,238.07Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M67.9,291.31s5.91,12,12.82,27,12.19,27.3,12.19,27.3-5.91-12-12.82-27S67.9,291.31,67.9,291.31Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M16.94,278.59s11.38,2.67,25.36,6.2,25.27,6.57,25.27,6.57-11.38-2.68-25.36-6.2S16.94,278.59,16.94,278.59Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M181.38,134.59c1.14.07,3.43-22.62,5.13-50.69s2.15-50.86,1-50.93-3.44,22.62-5.13,50.69S180.24,134.52,181.38,134.59Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M189.2,34.07c-.51-1-21.31,8.34-46.46,20.9S97.61,78.54,98.12,79.56s21.31-8.34,46.46-20.9S189.71,35.09,189.2,34.07Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M183.57,129.62c.63-1-17.88-14.29-41.33-29.79s-43-27.3-43.6-26.35S116.51,87.77,140,103.27,182.94,130.57,183.57,129.62Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M106,76.21l78.29,55.29,8.41-95Zm77.45,53.47L108,76.4l83.55-38.24Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M308.33,334.22c.49-1.19-23-11.88-52.4-23.87s-53.67-20.75-54.16-19.56,23,11.88,52.4,23.87S307.84,335.41,308.33,334.22Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M203.56,289.4c-1.28.18,1.2,25.84,5.52,57.32s8.87,56.86,10.15,56.68-1.2-25.84-5.53-57.32S204.83,289.23,203.56,289.4Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M303.8,330.07c-.79-1-21.78,14-46.88,33.45s-44.8,36.1-44,37.12,21.77-14,46.87-33.44S304.59,331.09,303.8,330.07Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M218.51,393.74,306.08,330l-98.62-43.43Zm85.32-63.52-84.4,61.45-10.65-103.3Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M110.18,213.87c.4-1-19.37-9.9-44.15-19.87s-45.2-17.24-45.61-16.24,19.36,9.9,44.15,19.87S109.77,214.88,110.18,213.87Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M21.92,176.59c-1.07.15,1.1,21.72,4.86,48.17s7.67,47.76,8.74,47.61-1.1-21.72-4.86-48.17S23,176.44,21.92,176.59Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M106.35,210.4c-.67-.85-18.25,11.82-39.28,28.3S29.53,269.22,30.2,270.08s18.26-11.82,39.28-28.3S107,211.25,106.35,210.4Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M34.88,264.26l73.39-53.95L25.19,174.17Zm71.49-53.73-70.72,52L26.31,175.7Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-102",
    cx: 47.35,
    cy: 194.61,
    rx: 26.15,
    ry: 66.24,
    transform: "translate(131.94 40.42) rotate(-14.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-103",
    cx: 13.05,
    cy: 203.79,
    rx: 40.34,
    ry: 67.14,
    transform: "translate(-7.57 190.41) rotate(-76.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "200.77 200.5 234.99 235.72 214.43 153.64 200.77 200.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "200.77 200.5 153.04 212.43 214.43 153.64 200.77 200.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "200.77 200.5 153.04 212.43 234.99 235.72 200.77 200.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M20.18,178.9s3.29-10.42,7-23.37S33.78,132,33.78,132s-3.29,10.42-7,23.37S20.18,178.9,20.18,178.9Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M54.19,214s-7.42-8-16.81-17.7S20.21,178.9,20.21,178.9s7.42,8,16.81,17.7S54.19,214,54.19,214Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M-27.52,190.84s10.75-2.43,23.92-5.73,23.81-6.22,23.81-6.22-10.75,2.43-23.93,5.73S-27.52,190.84-27.52,190.84Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-110",
    cx: 186.89,
    cy: 180.38,
    rx: 80.32,
    ry: 20.86,
    transform: "translate(120.99 120.02) rotate(-25.59)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-111",
    cx: 168.58,
    cy: 155.85,
    rx: 46.5,
    ry: 66.53,
    transform: "translate(176.08 26.6) rotate(-1.68)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "376.71 163.03 346.18 217.97 439.19 162.48 376.71 163.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "376.71 163.03 344.49 108.94 439.19 162.48 376.71 163.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "376.71 163.03 344.49 108.94 346.18 217.97 376.71 163.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M196.14,141.41s14,.18,31.25,0,31.23-.64,31.23-.64-14-.18-31.24,0S196.14,141.41,196.14,141.41Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M165.74,196s7.09-12.06,15.49-27.14,14.92-27.45,14.92-27.45-7.09,12.06-15.49,27.14S165.74,196,165.74,196Z",
    transform: "translate(180.57 21.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M163.91,87.35s6.94,12.28,15.84,27.21,16.41,26.88,16.41,26.88-6.94-12.28-15.85-27.21S163.91,87.35,163.91,87.35Z",
    transform: "translate(180.57 21.6)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    width: 900,
    height: 600,
    transform: "translate(1080.57 621.6) rotate(180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.61286058bec2c5468105168d45395465.svg";
export { ForwardRef as ReactComponent };